// extracted by mini-css-extract-plugin
export default {"info":"FPYyfzu8lH","h-rule":"WD07azRScm","hRule":"WD07azRScm","logo":"dp2ukrAtNL","further-resources":"IJanQNtG7A","furtherResources":"IJanQNtG7A"};